import { createContext, useContext, useState } from "react";

interface SelectedTabProviderProps {
  children: React.ReactNode;
}

type SelectedTabContextType = {
  selectedTab: string;
  setSelectedTab: (selectedTab: string) => void;
  preselectedTab?: string;
  setPreselectedTab: (preselectedTab: string) => void;
};

export const SelectedTabContext = createContext<SelectedTabContextType>({
  selectedTab: "Budget",
  setSelectedTab: () => {},
  preselectedTab: undefined,
  setPreselectedTab: () => {},
});

const SelectedTabProvider = (props: SelectedTabProviderProps) => {
  const [selectedTab, setSelectedTab] = useState<string>("Budget");
  const [preselectedTab, setPreselectedTab] = useState<string>();

  return (
    <SelectedTabContext.Provider
      value={{ selectedTab, setSelectedTab, preselectedTab, setPreselectedTab }}
    >
      {props.children}
    </SelectedTabContext.Provider>
  );
};

export default SelectedTabProvider;

export const useSelectedTab = () => {
  const { selectedTab, setSelectedTab, preselectedTab, setPreselectedTab } =
    useContext(SelectedTabContext);
  return { selectedTab, setSelectedTab, preselectedTab, setPreselectedTab };
};
